module.exports = __webpack_public_path__ + "img/esoteric-festival-2020-bush-techno-pherrol.3a17e745.jpg";